import React, { createContext, useContext, useState } from "react";

const HelpContext = createContext(null);

export function HelpProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [articleSlug, setArticleSlug] = useState("dashboard");

  function openHelp(slug) {
    setArticleSlug(slug || "dashboard");
    setOpen(true);
  }

  function closeHelp() {
    setOpen(false);
  }

  return (
    <HelpContext.Provider value={{ open, articleSlug, openHelp, closeHelp }}>
      {children}
    </HelpContext.Provider>
  );
}

export function useHelp() {
  const ctx = useContext(HelpContext);
  if (!ctx) throw new Error("useHelp must be used within a HelpProvider");
  return ctx;
}
